import {LOAD_REPORT_REQUEST,LOAD_REPORT_SUCCESS,LOAD_REPORT_FAILURE,RUN_REPORT_REQUEST,RUN_REPORT_SUCCESS,RUN_REPORT_FAILURE,GET_PARAM_VALUES_REQUEST,GET_PARAM_VALUES_SUCCESS,GET_PARAM_VALUES_FAILURE,SET_FILTER_DATA} from '../actions/reportAction';
import {RSAA} from 'redux-api-middleware'
import store from 'store';


export function getReportMetaData(id, runOnceVar) {
  return {
    [RSAA]: {
      endpoint: `/reporting/${id}`,
      method: 'GET',
      types: [
        LOAD_REPORT_REQUEST,
        {
            type: LOAD_REPORT_SUCCESS,
              payload: (action, status, response) => {
              return response.json().then((json) => { return {...json,
                   runOnce: runOnceVar
                 }
              }
          )
        }
        }, LOAD_REPORT_FAILURE
      ]
    }
  }
}


export function getReportResults(id, payload) {
  return {
    [RSAA]: {
      endpoint: `/reporting/data/${id}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      types: [
        {
            type: RUN_REPORT_REQUEST,
              payload: {
                    formData: payload
                 }
       },
       RUN_REPORT_SUCCESS,
        RUN_REPORT_FAILURE
      ]
    }
  }
}

export function getDynamicValues(id, param, payload){
  return {
    [RSAA]: {
      endpoint: `/reporting/${id}/param/${param}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      types: [
        GET_PARAM_VALUES_REQUEST,
        GET_PARAM_VALUES_SUCCESS,
        GET_PARAM_VALUES_FAILURE
      ]
    }
  }

}
